module.exports = "#ifdef USE_DECALMAP\n  varying vec2 vDecalUv;\n  uniform mat3 decalUVTransform;\n#endif\n";